import Blink from '@components/Blink'
import { ellipsis } from 'polished'
import { FunctionComponent, useCallback } from 'react'
import styled, { css } from 'styled-components'
import { StoryProps } from './types'
import useTracking from '@hooks/useTracking'
import config from '@config'

const {
  backend: { baseUrl },
} = config

const StyledWrapper = styled.li`
  min-width: 0;
  list-style-type: none;
`

const StyledBlink = styled(Blink)`
  ${({
    theme: {
      colors: { white },
    },
  }) =>
    css`
      display: flex;
      flex-direction: row;
      background-color: ${white};
      margin: 0;
      text-decoration: none;
    `}
`

const StyledOrder = styled.div`
  ${({
    theme: {
      fonts: { goodOT },
      colors: {
        brandColors: { brand_55 },
      },
    },
  }) => {
    return css`
      font-family: ${goodOT};
      font-size: 35px;
      font-style: normal;
      font-weight: 900;
      line-height: 22px;
      letter-spacing: 0px;
      text-align: left;
      color: ${brand_55};
      padding-top: 5px;
      width: 24px;
    `
  }}
`

const StyledContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 18px;
  overflow: hidden;
  justify-content: center;
`

const StyledTitle = styled.div`
  ${({
    theme: {
      fonts: { goodOT },
      colors: {
        grey: { grey_100 },
      },
    },
  }) => {
    return css`
      font-family: ${goodOT};
      font-size: 20px;
      font-style: normal;
      font-weight: 900;
      line-height: 22px;
      letter-spacing: 0px;
      text-align: left;
      margin-top: 4px;
      color: ${grey_100};
      ${ellipsis('100%', 2)}
      > strong {
        color: ${grey_100};
        font-weight: 900;
        font-style: normal;
      }
    `
  }}
`

const StyledCatchword = styled.div`
  ${({
    theme: {
      fonts: { goodOT },
      colors: {
        blicktvGrey: { btvGrey_60 },
      },
    },
  }) => {
    return css`
      font-family: ${goodOT};
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 17px;
      letter-spacing: 0px;
      text-align: left;
      color: ${btvGrey_60};
      ${ellipsis('100%', 1)}
      > strong {
        color: ${btvGrey_60};
        font-weight: 500;
        font-style: normal;
      }
    `
  }}
`

const Story: FunctionComponent<StoryProps> = ({
  title,
  catchword = '',
  order,
  link,
  articleId,
}) => {
  const onClick = useCallback(() => {
    return {
      event: 'click_meistgelesen',
      eventCategory: 'related content',
      eventLabel: `${baseUrl}/id${articleId}.html`,
      eventAction: `meistgelesen`,
    }
  }, [articleId])

  const trackOnClick = useTracking(onClick)

  return (
    <StyledWrapper>
      <StyledBlink {...link} onClick={trackOnClick}>
        <StyledOrder>{order}</StyledOrder>
        <StyledContent>
          {!!catchword && (
            <StyledCatchword
              dangerouslySetInnerHTML={{
                __html: catchword,
              }}
            />
          )}
          <StyledTitle
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
        </StyledContent>
      </StyledBlink>
    </StyledWrapper>
  )
}

export default Story
